<template>
  <div class="pcHeader">
    <div class="w1200">
      <div class="logo"></div>
      <div class>
        <ul class="nav relative">
          <template v-for="(item, index) in menus">
            <li
              :key="index"
              :class="{ active: active == index }"
              @click="routerLink(item, index)"
              @mouseover="onmouseoverItem(item, index)"
            >
              {{ item.name }}
              <i
                class="el-icon-arrow-down"
                v-if="index == 1 && !showMenuDialog"
              ></i>
              <i
                class="el-icon-arrow-up"
                v-if="index == 1 && showMenuDialog"
              ></i>
            </li>
          </template>
          <transition name="el-zoom-in-top">
            <ul v-if="showMenuDialog" class="menuDialog" @mouseleave="showMenuDialog = false">
              <template v-for="(itemChild, i) in menusChildren">
                <li
                  :key="i"
                  :class="{ active: activeChild === i }"
                  @click="routerLink1(itemChild, i)"
                >
                  {{ itemChild.name }}
                </li>
              </template>
            </ul>
          </transition>
        </ul>
      </div>
      <div class="search cursor dialogLink">
        <div @click="showSearchForm = !showSearchForm">
          <i class="el-icon-service dialogLink"></i>
          <em class="dialogLink">&nbsp;联系我们&nbsp;</em>
          <i v-if="!showSearchForm" class="el-icon-arrow-down dialogLink"></i>
          <i v-else class="el-icon-arrow-up dialogLink"></i>
        </div>
        <transition name="el-zoom-in-top">
          <div
            class="searchCon"
            v-if="showSearchForm"
            @mouseenter="isLeaveDialog = false"
            @mouseleave="isLeaveDialog = true"
          >
            <div class="title">
              <i class="el-icon-service"></i>
              <em>&nbsp;填写您的联系方式，我们会主动与您联系</em>
            </div>
            <ul class="searchForm">
              <li :class="{ active: focusIdx == 1 }">
                <el-input
                  v-model="form.name"
                  clearable
                  placeholder="联系人*"
                  @blur="focusIdx = 0"
                  @focus="focusIdx = 1"
                ></el-input>
              </li>
              <li :class="{ active: focusIdx == 2 }">
                <el-input
                  v-model="form.tel"
                  clearable
                  placeholder="手机号*"
                  @blur="focusIdx = 0"
                  @focus="focusIdx = 2"
                ></el-input>
              </li>
              <li :class="{ active: focusIdx == 3 }">
                <el-input
                  v-model="form.company"
                  clearable
                  placeholder="公司名称"
                  @blur="focusIdx = 0"
                  @focus="focusIdx = 3"
                ></el-input>
              </li>
              <li :class="{ active: focusIdx == 4 }">
                <el-input
                  v-model="form.direction"
                  clearable
                  placeholder="合作方向"
                  @blur="focusIdx = 0"
                  @focus="focusIdx = 4"
                ></el-input>
              </li>
              <li :class="{ active: focusIdx == 5 }">
                <el-input
                  v-model="form.mail"
                  clearable
                  placeholder="电子邮箱"
                  @blur="focusIdx = 0"
                  @focus="focusIdx = 5"
                ></el-input>
              </li>
              <li class="mar20_t">
                <el-button type="primary" class="w100_per" @click="onSubmit">
                  提交
                </el-button>
              </li>
            </ul>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import {validatePhone,validateEMail,validate20Chart} from '@/utils/utils'
export default {
  data() {
    return {
      showMenuDialog: false,
      showSearchForm: false,
      isLeaveDialog: true,
      active: 0,
      activeChild: '',
      focusIdx: 0,
      isHover: false,
      menus: [
        { name: '首页', url: '/home', activeName: 'home' },
        {
          name: '解决方案',
          url: '/solution/0',
          activeName: 'solution',
        },
        { name: '动态', url: '/news', activeName: 'news' },
        { name: '合作伙伴', url: '/partner', activeName: 'partner' },
      ],

      menusChildren: [
        {
          name: '农产品交易中心数字化解决方案',
          url: '/solution/5',
          activeName: 'solution',
        },
        {
          name: '乡村振兴数字化解决方案',
          url: '/solution/0',
          activeName: 'solution',
        },
        {
          name: '农业单品行业大数据解决方案',
          url: '/solution/1',
          activeName: 'solution',
        },
        {
          name: '农业链主企业数字化解决方案',
          url: '/solution/2',
          activeName: 'solution',
        },
        {
          name: '现代农业产业园数字化解决方案',
          url: '/solution/3',
          activeName: 'solution',
        },
        {
          name: '农产品区域公用品牌数字化解决方案',
          url: '/solution/4',
          activeName: 'solution',
        },
      ],

      form: {
        name: '',
        tel: '',
        company: '',
        direction: '',
        mail: '',
      },
    }
  },

  watch: {
    $route() {
      this.routerChange()
    },
  },
  created() {
    // 初始加载选中实践
    this.routerChange()
    // 滚动条事件
    window.addEventListener('scroll', () => {
      this.showSearchForm = false
    })
    document.addEventListener(
      'click',
      (ev) => {
        if (
          this.isLeaveDialog &&
          ev.target.className.indexOf('dialogLink') < 0
        ) {
          this.showSearchForm = false
        }
      },
      false,
    )
  },

  methods: {
    routerChange() {
      this.showMenuDialog = false
      this.active = this.menus.findIndex(
        (val) => this.$route.path.indexOf(val.activeName) > -1,
      )
      console.log(this.$route.path, this.menusChildren)
      this.activeChild = this.menusChildren.findIndex(
        (val) => this.$route.path.indexOf(val.url) > -1,
      )
      //this.activeChild = this.activeChild > -1 ? this.activeChild : 0;
    },
    onmouseoverItem(item, index) {
      console.log("index===", index);
      if (index == 1) {
        this.showMenuDialog = true;
      } else {
        this.showMenuDialog = false;
      }
    },
    routerLink(item, index) {
      if (index == 1) {
        this.showMenuDialog = !this.showMenuDialog
      } else {
        if (this.active !== index || this.$route.path != item.url) {
          this.$router.push(item.url)
        }
      }
    },
    routerLink1(item, index) {
      if (this.activeChild !== index) {
        this.$router.push(item.url)
      }
    },

    onSubmit() {
      if (! validate20Chart(this.form.name)) {
        this.$message.warning('请填写正确的联系人姓名')
        return
      }
      if (! validatePhone(this.form.tel)) {
        this.$message.warning('请填写正确的联系人手机号')
        return
      }
      if(this.form.company.length > 30) {
        this.$message.warning("公司名称太长");
        return
      }
      if(this.form.direction.length > 30) {
        this.$message.warning("合作方向太长");
        return
      }
      if(! validateEMail(this.form.mail)) {
        this.$message.warning("请填写正确的联系邮箱");
        return
      }
      // if (this.form.company.length < 2) {
      //   this.$message.warning('请填写公司名称')
      //   return
      // }
      // if (this.form.direction.length < 1) {
      //   this.$message.warning('请填写合作方向')
      //   return
      // }
      // if (this.form.mail.length < 2) {
      //   this.$message.warning('请填写联系邮箱')
      //   return
      // }
      let strTemp =
        this.form.name +
        '_' +
        this.form.tel +
        '_' +
        this.form.company +
        '_' +
        this.form.direction +
        '_' +
        this.form.mail
      this.$store
        .dispatch('api/informationsAdd', {
          informations: strTemp,
          system_id: '1',
        })
        .then((response) => {
          if (response.code == 0) {
            this.$message.success('提交成功')
            this.showSearchForm = false
          }
        })
    },
  },
}
</script>

<style lang="scss">
@import './index.scss';
</style>
